module.exports = __webpack_public_path__ + "img/weathericons-regular-webfont.ecaf8b48.svg";